module.exports = __webpack_public_path__ + "img/selected7-min.d39b5ce6.png";